import React from 'react';

const SvgRectangle = ({ cx, cy, color, mouseEnter, mouseLeave, index }) => (
  <svg
    cx={cx}
    cy={cy}
    x={cx - 5}
    y={cy - 5}
    fill={color}
    width={10}
    height={10}
    onMouseEnter={() => mouseEnter(cx, cy, index)}
    onMouseLeave={() => mouseLeave()}
  >
    <path fill={color} stroke={color} d="M0 0h7v7H0z" />
  </svg>
);

export default SvgRectangle;
